module.exports = __webpack_public_path__ + "img/greatux.36d7f619.webp";